

















































































































































































































































































































/* eslint-disable */

import Vue from "vue";
import { itemApi } from "../utils/axios";
import moment from "moment";
import TimeSelect from "../utils/vuetify-time-select/TimeSelect.vue";
import DaumPostcode from "vuejs-daum-postcode";
import { colors } from "vuetify/lib";

export default Vue.extend({
  components: { TimeSelect, DaumPostcode },
  name: "PostView",
  data: () => ({
    uid: "",
    title: "",
    description: "",
    category: "",
    location: "",
    startPrice: "",
    happyPrice: "",
    grade: "",
    direct: "",
    startDate: "",
    endDate: "",
    files: [],
    filesPreview: [],
    uploadImageIndex: 0,

    categories: ["전자기기","의류","미용","잡화","도서"],

    startDateCalender: false,
    startTime: "",
    startTimeDialog: false,

    endDateCalender: false,
    endTime: "",
    endTimeDialog: false,

    todayDate: "",
    todayTime: "",

    startDateTime: "",
    endDateTime: "",
    rules: {
      price: (v: string) =>
        !!(v || "").match(/^[1-9][0-9]*$/) ||
        "잘못된 입력입니다. 가격을 입력해주세요.",
    },

    uploadFlag: 0,
  }),
  created() {
    const today = moment();

    this.startDate = this.todayDate = today.format("YYYY-MM-DD");
    this.startTime = this.todayTime = today.format("HH:mm");
    this.startDateTime = this.startDate + " " + this.startTime;
    this.endDate = today.add(1, 'd').endOf('day').format("YYYY-MM-DD")
    this.endTime = today.format("HH:mm")
    this.endDateTime = this.endDate + " " + this.endTime;

    this.uid = this.$store.state.userModule.user.object.user.id;
    
    // console.log(this.$refs.title);
    // ((this.$refs.title as any).input as any).focus();
  },
  methods: {
    async writePost() {
      if (this.uploadFlag == 1) return;

      this.uploadFlag = 1;
      
      const today = moment();
      this.startDate = today.format("YYYY-MM-DD");
      this.startTime = today.format("HH:mm");
      
      this.startDateTime = this.startDate + " " + this.startTime;
      this.endDateTime = this.endDate + " " + this.endTime;

      const {
        uid,
        title,
        description,
        category,
        location,
        startPrice,
        happyPrice,
        grade,
        direct,
        startDateTime,
        endDateTime,
        files,
      } = this;

      if (!title) alert("제목을 입력해주세요.");
      else if (!description) alert("내용을 입력해주세요.");
      else if (!category) alert("카테고리를 선택해주세요.");
      else if (!location) alert("위치를 입력해주세요.");
      else if (!startPrice) alert("경매시작가를 입력해주세요.");
      else if (!happyPrice) alert("즉시구매가를 입력해주세요.");
      else if (Number(startPrice) >= Number(happyPrice))
        alert("경매시작가는 즉시구매가보다 작아야합니다.");
      else if (!grade) alert("상품등급을 입력해주세요.");
      else if (!endDateTime) alert("경매종료일을 입력해주세요.");
      else if (files.length === 0) alert("사진을 입력해주세요.");
      else {
        const formData = new FormData();

        formData.append("title", title);
        formData.append("description", description);
        formData.append("category", category);
        formData.append("location", location);
        formData.append("startPrice", startPrice);
        formData.append("happyPrice", happyPrice);
        formData.append("grade", grade);
        formData.append("direct", direct);
        formData.append("startDateTime", startDateTime);
        formData.append("endDateTime", endDateTime);

        // user id, image
        formData.append("uid", uid);

        files.forEach((el) => {
          formData.append("files", (el as any).file);
        });

        const { data } = await itemApi.item(formData);

        // state true?
        // console.log(data);
        if (data.status) {
          alert("업로드가 완료되었습니다.");
          this.$emit("close");
          // window.location.reload();
          // 업로드 후 자동 라우팅 -> 아이템 번호 필요
          this.$router.replace({ path: '/auction' });
        } else {
          alert("업로드에 실패하였습니다.");
        }
      }

      this.uploadFlag = 0;
    },

    imageUpload() {
      console.log(this.$refs.files);
      console.log((this.$refs.files as any).files);

      // 배열을 생성하는데
      // 실제파일을 관리하는 부분, 이미지 preview를 관리하는 부분, index까지 관리하는 배열을 제작
      let num = -1;
      for (let i = 0; i < (this.$refs.files as any).files.length; i++) {
        (this.files as any) = [
          ...this.files,
          {
            // 실제 파일
            file: (this.$refs.files as any).files[i],
            // 이미지 프리뷰
            preview: URL.createObjectURL((this.$refs.files as any).files[i]),
            number: i,
          },
        ];
        num = i;
      }
      this.uploadImageIndex = num + 1;
      //console.log(this.files);
    },

    imageAddUpload() {
      console.log(this.$refs.files);
      console.log((this.$refs.files as any).files);
      // 배열을 생성하는데
      // 실제파일을 관리하는 부분, 이미지 preview를 관리하는 부분, index까지 관리하는 배열을 제작
      let num = -1;
      for (let i = 0; i < (this.$refs.files as any).files.length; i++) {
        (this.files as any) = [
          ...this.files,
          {
            // 실제 파일
            file: (this.$refs.files as any).files[i],
            // 이미지 프리뷰
            preview: URL.createObjectURL((this.$refs.files as any).files[i]),
            number: i + this.uploadImageIndex,
          },
        ];
        num = i;
      }
      this.uploadImageIndex = this.uploadImageIndex + num + 1;
      console.log(this.files);
    },

    fileDeleteButton(e: any) {
      const name = e.target.getAttribute("name");
      this.files = this.files.filter(
        (data) => (data as any).number !== Number(name)
      );
    },

    startPriceCheck() {
      if (!this.startPrice.match(/^[1-9][0-9]*$/)) {
        this.startPrice = "";
      }
    },

    happyPriceCheck() {
      if (!this.happyPrice.match(/^[1-9][0-9]*$/)) {
        this.happyPrice = "";
      }
    },

    handleAddress(data: any) {
      let fullAddress = data.address;
      let extraAddress = "";
      if (data.addressType === "R") {
        if (data.bname !== "") {
          extraAddress += data.bname;
        }
        if (data.buildingName !== "") {
          extraAddress +=
            extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
        }
        fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      }

      console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
      this.location = fullAddress;
    },

    locationEdit() {
      this.location = "";
    },
  },
});
